module.exports = __webpack_public_path__ + "static/profile-aa2cace65dd1ea93a18b1b34927062de.jpg";